export const getLayoutElementStyleSelector = (state) => state.layoutElementStyleReducer;
